import project1 from '../../assets/nftMap.png';
import project2 from '../../assets/muia.png';
import project3 from '../../assets/pathSynch.png';
import project4 from '../../assets/retwho.png';
import project5 from '../../assets/knowledge.jpeg';
import project6 from '../../assets/eye.png';
import project7 from '../../assets/backend2.jpg';
import project8 from '../../assets/backend1.jpg';
import project9 from '../../assets/planet.png';
// import project10 from '../../assets/1.jpg';
// import project11 from '../../assets/3.jpg';
// import project12 from '../../assets/1.jpg';

export const portfolioList = [
  {
    name: 'Nft Map',
    img: project1,
    liveLink: 'http://nft-map.netlify.app/',
    category: 'all',
  },
  {
    name: 'Muia Materials',
    img: project2,
    liveLink: 'http://muiamaterials.energy/',
    category: 'all',
  },
  {
    name: 'Eye Rest app',
    img: project6,
    liveLink: 'https://github.com/phrubel/eye-rest-app',
    category: 'all',
  },
  {
    name: 'PathSynch',
    img: project3,
    liveLink: 'https://apps.apple.com/us/app/pathsynch/id6477720135',
    category: 'mobile',
  },
  {
    name: 'Retwho',
    img: project4,
    liveLink:
      'https://play.google.com/store/apps/details?id=com.retwho.aizaf.group',
    category: 'mobile',
  },

  {
    name: 'Knowledge Temple',
    img: project5,
    liveLink: 'https://play.google.com/',
    category: 'mobile',
  },

  {
    name: 'Knowledge Temple Server',
    img: project7,
    liveLink: 'https://github.com/phrubel/knowledge-temple-backend',
    category: 'backend',
  },
  {
    name: 'Server Monitoring',
    img: project8,
    liveLink: 'https://github.com/phrubel/server-upTime-monitoring-app',
    category: 'backend',
  },
  {
    name: 'Planets',
    img: project9,
    liveLink: 'https://github.com/phrubel/planets-native',
    category: 'mobile',
  },
  // {
  //   name: 'Ride Share',
  //   img: project10,
  //   liveLink: 'rubel.com',
  // },
  // {
  //   name: 'Ride Share',
  //   img: project11,
  //   liveLink: 'rubel.com',
  // },
  // {
  //   name: 'Ride Share',
  //   img: project12,
  //   liveLink: 'rubel.com',
  // },
];
